import React from 'react';
import Modal from '@common/modal';
import CloseButton from '@components/common/closeButton';
import Text from '@components/common/text';
import { FontStyle } from '@domain/constant/fontStyle';
import classnames from 'classnames/bind';
import styles from './index.module.scss';

const cx = classnames.bind(styles);

interface CoordinationModalProps {
  visible: boolean;
  optionSn: number | null;
  interviewLocation: string | null;
  date?: string | null;
  handleErrors: (result: string) => void;
  onClose: () => void;
}

const CoordinationModal = ({
  visible,
  optionSn,
  interviewLocation,
  date,
  handleErrors,
  onClose,
}: CoordinationModalProps) => {
  return (
    <Modal visible={visible} isUseScrollHidden={false}>
      <div className={cx('inner')}>
        <CloseButton className={cx('btnClose')} onClick={onClose} />

        <Text fontStyle={FontStyle.H4_B}>다른 일정에 면접을 보고싶나요?</Text>

        <p className={cx('notification')}>
          면접 일정을 조율할 수 있는지
          <br />
          인사담당자님께 전달해 드릴게요.
        </p>

        <div className={cx('textareaWrap')}>
          <textarea className={cx('textarea')} placeholder="원하는 면접 일정을 알려주세요." maxLength={100} />
          <div className={cx('infoText')}>
            최대 글자수 : <span className={cx('value')}>{31}</span> / 100
          </div>
        </div>

        <button className={cx('btn')} role={'button'} onClick={() => {}}>
          확인
        </button>
      </div>
    </Modal>
  );
};
export default CoordinationModal;
